import {clsx, styled, Box} from 'external/material'
import useTranslations from 'hooks/translations'
import useHomework from 'hooks/homework'

const StyledComments = styled(Box)(homeworkBodyStyles)

export default function HomeworkHistory(props) {

  const {status} = props
  const {translate, formatDateTime} = useTranslations()
  const {getStatus, homework = {}} = useHomework()
  const {properties = {}} = homework.homework || {}
  const total = properties.score || ''
  
  return (
    <StyledComments>
      {status.map((s, i)=> {
        const status = getStatus(s.status)
        const statusName = translate(`homework-status-${status}`)
        return (
          <Box key={i} className="comment">                  
            <Box className="header">
              <div className={clsx('status-date')}>{formatDateTime(s.created)}</div>
              <div className="status-score">{`${s.score || '-'}/${total}`}</div>
              <div className={clsx('status-name', status)}>{statusName}</div>
            </Box>
            <Box className="message">
              {s.message}
            </Box>
          </Box>)
      })}            
    </StyledComments>
  )
}

function homeworkBodyStyles() {
    return {   
      "& .comment": {
        padding: '5px 0',
        borderBottom: '1px dotted #ccc',
        color: '#555',
        '& .header': {
          display: 'flex',
          '& .status-date': {
            flexGrow: 1,
          },
          '& .status-score': {
            marginRight: 20
          }
        }
      },   
        minWidth: 400,
        display: 'flex',
          flexDirection: 'column',
        padding: '20px 20px',
        '& .status-name': {
          padding: '0',
          color: '#fff',
          borderRadius: '20px',
          width: 80,
          textAlign: 'center',
          fontSize: '.8em',
          '&.assigned': {
            backgroundColor: '#f78d43'
          },
          '&.completed': {
            backgroundColor: '#06b71c'
          },
          '&.pending': {
            backgroundColor: '#0ac7ff'
          },
          '&.returned': {
            backgroundColor: '#ff0a0a'
          }
      }, 
    }
}

